'use strict';

import pusherProvider from './provider';

const MODULE_NAME = 'brg.pubsub.pusher';

var app = angular.module(MODULE_NAME, []);
app.provider('pusher', pusherProvider);

export default MODULE_NAME;
